module.exports = __webpack_public_path__ + "static/img/frack3.24b8c0b5.png";